exports.components = {
  "component---themes-gatsby-theme-beluga-src-pages-404-tsx": () => import("./../../../../../themes/gatsby-theme-beluga/src/pages/404.tsx" /* webpackChunkName: "component---themes-gatsby-theme-beluga-src-pages-404-tsx" */),
  "component---themes-gatsby-theme-beluga-src-templates-index-tsx": () => import("./../../../../../themes/gatsby-theme-beluga/src/templates/index.tsx" /* webpackChunkName: "component---themes-gatsby-theme-beluga-src-templates-index-tsx" */)
}

